import axios, { AxiosInstance } from 'axios';

export const clientAxios: AxiosInstance = axios.create({
  // baseURL: "https://testsimplexplatformusermanagerapi.satrack.com/api/v1/",//ambiente pruebas
  baseURL: '%REACT_APP_URL_GET_MENU%',
});